import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {DialogModule} from "primeng/dialog";
import {ProyectoItem, ProyectoTramiteItem} from "../../../../interfaces/proyecto.interface";
import {ProyectoService} from "../../../../proyectos/services/proyecto.service";
import {CurrencyPipe, NgIf, NgTemplateOutlet} from "@angular/common";
import {TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {CheckboxModule} from "primeng/checkbox";
import {TramiteService} from "../../../services/tramite.service";
import {TooltipModule} from "primeng/tooltip";
import {FormsModule} from "@angular/forms";
import {ButtonDirective} from "primeng/button";
import {Ripple} from "primeng/ripple";
import {MessagesModule} from "primeng/messages";
import {MessageModule} from "primeng/message";
import {CategoriaTramiteEnum, EstadoTramiteEnum} from "../../interfaces/tramites.interface";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {
    TagInformativoTramiteExpresComponent
} from "./tag-informativo-tramite-expres/tag-informativo-tramite-expres.component";

@Component({
  selector: 'app-dialog-tramites-expres',
  standalone: true,
    imports: [
        ProgressSpinnerModule,
        DialogModule,
        CurrencyPipe,
        NgIf,
        NgTemplateOutlet,
        TableModule,
        TagModule,
        CheckboxModule,
        TooltipModule,
        FormsModule,
        ButtonDirective,
        Ripple,
        MessagesModule,
        MessageModule,
        OverlayPanelModule,
        TagInformativoTramiteExpresComponent,
    ],
  templateUrl: './dialog-tramites-expres.component.html',
  styleUrl: './dialog-tramites-expres.component.scss'
})
export class DialogTramitesExpresComponent implements OnInit{
    @Input()visible: boolean = false;
    @Input() selected?: ProyectoItem | null = null;
    @Output() onEventEmitterClose = new EventEmitter<boolean>();
    @Output() onEventEmitterProcesar = new EventEmitter<ProyectoTramiteItem[]>();
    datosCargados: boolean = false;
    tramitesPorProyecto: ProyectoTramiteItem[] = [];
    protected readonly EstadoTramiteEnum = EstadoTramiteEnum;
    protected readonly CategoriaTramiteEnum = CategoriaTramiteEnum;
    constructor(private proyectoService: ProyectoService, protected tramiteService: TramiteService) {
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
        this.getTramitesProyecto();
    }

    showDialog() {
        this.visible = true;
    }
    hiddeDialog() {
        this.tramiteService._tramiteItemSeletected.set([]);
        this.onEventEmitterClose.emit(false);
        this.datosCargados = false;
    }

    title() {
        let tituloDialog = ''
        if (this.selected) {
            tituloDialog = `TRAMITES SOLICITADOS - SOLICITUD #${this.selected.numeroExpediente}`
        }
        return tituloDialog;
    }

    private getTramitesProyecto() {
        if (this.selected && this.selected?.idProyecto!==undefined) {
            this.proyectoService.getTramitesProyectos(this.selected?.idProyecto!)
                .subscribe({
                    next: (result) => {
                        if (result.status == 200) {
                            this.datosCargados = true
                            this.tramitesPorProyecto = result.body!
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    }
                });
        }

    }
    onCheckboxChange(event: any, tramite: ProyectoTramiteItem) {
        event.originalEvent.stopPropagation();
        let check = event.checked;
        if (check) {
            this.tramiteService._tramiteItemSeletected.set([...this.tramiteService.tramiteItemSeletected(), tramite]);
        } else {
            this.tramiteService._tramiteItemSeletected.set(this.tramiteService.tramiteItemSeletected().filter(p => p.idTramite !== tramite.idTramite));
        }
    }

    onCheckboxDisabled(tramite: ProyectoTramiteItem): boolean{
        const items = this.tramiteService.tramiteItemSeletected();
        return items.some(t => t.idEstadoTramite === 3) &&
            tramite.idEstadoTramite === 3 &&
            !items.some(t => t.idTramite === tramite.idTramite);
    }

    mostrarInfoIcon(tramite: ProyectoTramiteItem): boolean {
        const categoria = Number(tramite?.idCategoria);
        const seleccionados = this.tramiteService.tramiteItemSeletected();

        if (tramite?.idEstadoTramite !== EstadoTramiteEnum.FormularioCompleto) return true;

        //Tiene categoraa especial express integrada
        if (categoria === CategoriaTramiteEnum.ServicioOnlineExpresporTramiteIntegrado) return true;

        //Otro trrmite de la misma categoría esta seleccionado y este esta habilitado
        const otroMismaCategoria = seleccionados.some(t =>
            t.idTramite !== tramite.idTramite && Number(t.idCategoria) === categoria
        );

        return otroMismaCategoria && !this.onCheckboxDisabled(tramite);
    }

    isProyectoSeleccionado(idTramite: number): boolean {
        return this.tramiteService.tramiteItemSeletected().some(p => p.idProyecto === idTramite);
    }

    procesarTramiteExpress() {
        this.onEventEmitterProcesar.emit(this.tramiteService.tramiteItemSeletected());
        this.hiddeDialog();
    }
}
